import React from 'react';
import type { SiderProps as BaseSiderProps } from 'antd';

import { Sider } from './styled.ts';

export const BaseSiderLayout: React.FC<BaseSiderProps> = ({ className, ...props }) => (
    <Sider className={className} {...props} />
);
